<template>
  <div class="main">
		<div class="mainBox">
			<h1 class="logo"></h1>
			<p class="slogan">聽覺導覽<br>音訊服務平台</p>
			<p class="sloganSub">讓創作者與閱聽者之間沒。有。距。離</p>
			<ul class="sloganList">
				<li><h3>手機就可開通導覽功能</h3>使用手機與現場開通，立即讓參與者「聲」入情境，讓藝術展演不只是心領神會，更能完整傳達理念。</li>
				<li><h3>閱聽數據分析</h3>讓每場展演都能累積閱聽數據，分析受眾的內容喜好。</li>
				<li><h3>AI運算協助轉換四國語言</h3>別再讓藝術展演的說明與引導，因為語言而跨足不前；透過AI運算多語系（中／英／日／韓）的服務，讓藝術與世界沒有距離。</li>
			</ul>
			<p class="hightLight">服務即將上線，敬請期待。</p>
			<p class="mail">合作洽詢：<a href="mailto:info@yscreatech.com">info@yscreatech.com</a></p>
			<div class="sloganfooter">©2014-2019 SYSTEM of Young Square Createch Ltd. All Rights Reserved. <br>揚揚創新科技，版權所有。禁止任何侵害著作權之行為。</div>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
